
document.addEventListener('DOMContentLoaded', adjustHeight);
window.addEventListener('resize', adjustHeight);

function adjustHeight() {
  if (window.innerWidth < 920) {
    return;
  }

  var elements = document.getElementsByClassName('js_same-height');
  var adjusted = [];

  for (var i = 0; i < elements.length; i++) {
    var element1 = elements[i];
    var dataParam = element1.dataset.heightId;
    var element2 = document.querySelectorAll('[data-height-id="' + dataParam + '"]')[1];
    var h1 = element1.offsetHeight;
    var h2 = element2.offsetHeight;
    var finalHeight = h1 > h2 ? h1 : h2;

    if (!adjusted.includes(element2)) {
      adjusted.push(element1);
      adjusted.push(element2);

      console.log(element1, h1, finalHeight);
      console.log(element2, h2, finalHeight);

      element1.style.height = finalHeight + 'px';
      element2.style.height = finalHeight + 'px';
    }
  }
}
